import ReadyToLearn from '@/dataroom/ui/components/Landing/dealvdr/components/ReadyToLearn';
import Intro from './Intro';
import Features from './Features';
import Customers from './Customers';
import Feedbacks from './Feedbacks';

const Home = () => (
  <>
    <Intro />
    <Customers />
    <Features />
    <Feedbacks />
    <ReadyToLearn />
  </>
);

export default Home;
